import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { routes } from "./routes/routes";
import { AppMenu } from "./features/appMenu/AppMenu";
import GlobalSnackbar from "./features/snackbar/GlobalSnackbar";
import GlobalDialog from "./features/globalDialog/GlobalDialog";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { getHealth, selectStatus } from "./features/globalDialog/globalDialogSlice";
import { globalDialogStatus } from "./features/globalDialog/globalDialogTypes";

function App(): JSX.Element {
  const dispatch = useAppDispatch();

  const status = useAppSelector(selectStatus);

  //call backend every ten minutes to keep the lambdas warm
  useEffect(() => {
    // eslint-disable-next-line scanjs-rules/call_setInterval
    const interval = setInterval(() => {
      dispatch(getHealth(1));
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  return status == globalDialogStatus.loaded ? (
    <div className="App">
      <GlobalSnackbar />
      <Router>
        <AppMenu></AppMenu>
        <Switch>
          <Route exact path="/">
            <Redirect to="/uebersicht" />
          </Route>
          <MapRoutes routes={routes}></MapRoutes>
        </Switch>
      </Router>
    </div>
  ) : (
    <GlobalDialog />
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MapRoutes = (params: any) => {
  return (
    <React.Fragment>
      {params.routes.map((e: any) => {
        // eslint-disable-line @typescript-eslint/no-explicit-any
        if (e.items) {
          return <MapRoutes key={e.name} routes={e.items}></MapRoutes>;
        } else {
          let path = e.path;
          if (e.params) path = e.path + e.params;
          if ("path" in e && "component" in e) return <Route key={e.name} exact path={path} component={e.component} />;
        }
      })}
    </React.Fragment>
  );
};

export default App;
